import React from "react";
import { Spinner } from "reactstrap";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Loader = (props) => {
  return (
    <React.Fragment>
      <div className="d-flex justify-content-center mx-2 mt-2">
        <lord-icon
          src="https://cdn.lordicon.com/msoeawqm.json"
          trigger="loop"
          colors="primary:#014c94,secondary:#eac22f"
          style={{ width: "72px", height: "72px" }}
        ></lord-icon>
      </div>
      {/* <div className="d-flex justify-content-center mx-2 mt-2">
                <Spinner color="primary" size={30}> Loading... </Spinner>
            </div> */}
      {toast.error(props.error, {
        position: "top-right",
        hideProgressBar: false,
        progress: undefined,
        toastId: "",
      })}
    </React.Fragment>
  );
};

export default Loader;
